import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import theme from "./theme";

// Global Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import SubService from "./pages/SubService";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ServicesAdminPage from "./pages/ServicesAdminPage";
import Projects from "./pages/Projects";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import ServiceRequest from "./pages/ServiceRequest";
import PlanRequest from "./pages/PlanRequest";
import CustomQuoteRequest from "./pages/CustomQuoteRequest";
import DesignTemplatesPage from "./components/DesignTemplatesPage";
import Contactus from "./pages/contactus";
import NotFound from "./pages/NotFound.jsx";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />

      {/* ✅ All routes go here */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
        <Route path="/services/:serviceId/subservices" element={<SubService />} />
        <Route path="/admin/services" element={<ServicesAdminPage />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/about" element={<About />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/service-request" element={<ServiceRequest />} />
        <Route path="/plan-request" element={<PlanRequest />} />
        <Route path="/work-together" element={<CustomQuoteRequest />} />
        <Route path="/design-templates" element={<DesignTemplatesPage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
      <ScrollToTop />
    </ThemeProvider>
  );
}

export default App;
